const Cloud = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z"
      fill="url(#paint0_linear_1_30)"
    />
    <path
      d="M22 14H20.74C20.3659 12.551 19.5928 11.236 18.5086 10.2044C17.4245 9.1728 16.0727 8.46599 14.6069 8.16428C13.1411 7.86256 11.6201 7.97804 10.2166 8.49759C8.8132 9.01714 7.58363 9.91994 6.66764 11.1034C5.75165 12.2868 5.18598 13.7035 5.0349 15.1924C4.88381 16.6812 5.15338 18.1826 5.81296 19.526C6.47255 20.8693 7.4957 22.0007 8.76617 22.7916C10.0366 23.5824 11.5035 24.0011 13 24H22C23.3261 24 24.5978 23.4732 25.5355 22.5355C26.4732 21.5979 27 20.3261 27 19C27 17.6739 26.4732 16.4021 25.5355 15.4645C24.5978 14.5268 23.3261 14 22 14V14Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_30"
        x1="0"
        y1="16"
        x2="32"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3EC6EB" />
        <stop offset="1" stopColor="#3885FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default Cloud;
